<!-- @format -->

<codemirror>
  <style>
    .CodeMirror {
      border-top: 1px solid black;
      border-bottom: 1px solid black;
      border-radius: 8px;
      font-size: 14px;
      line-height: 1.4em;
      border: 1px solid #cdcdcd;
    }
    .CodeMirror-selectedtext {
      color: white;
    }
    .styled-background {
      background-color: #ff7;
    }
    .level-50 {
      background-color: #f7dfe8;
    }
    .level-60 {
      background-color: #f4d7e5;
    }
    .level-70 {
      background-color: #f4c6d9;
    }
    .level-80 {
      background-color: #f2adc3;
    }
    .level-90 {
      background-color: #f492ac;
    }
    .level-100 {
      background-color: #f96d87;
    }
  </style>

  <script>
    export default {
      cm: null,
      emitcm: null,
      onMounted(props, state) {
        let width = typeof props.width !== "undefined" ? props.width : "auto";
        let height =
          typeof props.height !== "undefined" ? props.height : "auto";
        let readonly = typeof props.readonly !== "undefined" ? true : false;
        this.emitcm =
          typeof props.onupdate !== "undefined" ? props.onupdate : null;

        this.root.innerHTML = "";
        this.cm = CodeMirror(this.root, {
          mode: "simplemode",
          readOnly: readonly,
          autofocus: true,
          label: "label",
          styleActiveLine: false,
          lineNumbers: true,
          lineWrapping: true,
          scrollbarStyle: "simple",
          gutters: ["CodeMirror-linenumbers", "leafpoints"],
          tabSize: 4,
        });
        this.cm.setSize(width, height);
        this.onUpdated(props, state);
      },
      onUpdated(props, state) {
        //本文更新
        this.cm.setValue(props.value);

        // origin or target
        const markerType =
          props.type == "origin" ? "origin_marker" : "target_marker";

        // 網掛け
        const mark = (marker, defaultLevel = 50, select = false) => {
          let level = defaultLevel;
          if (marker.ratio && marker.ratio > 0.5) {
            level = Math.floor(marker.ratio * 10) * 10;
          }
          for (const pos of marker[markerType]) {
            this.cm.markText(pos[0], pos[1], {
              className: `level-${level}`,
            });
            if (select) {
              this.cm.setSelection(pos[0], pos[1]);
            }
          }
        };

        // 全体の網掛け
        if (props.markers) {
          for (const marker of props.markers) {
            mark(marker, marker.ratio ? 50 : 60);
          }
        }

        // フォーカス部分の網掛け
        if (props.marker) {
          mark(props.marker, props.marker.ratio ? 50 : 100, true);
        }
      },
    };
  </script>
</codemirror>
